<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
            <b-row>
              <b-col md="8">
                <h2>{{$t('message.Jobs')}}</h2>
                <div class="d-flex justify-content-start ms-5">
                  <b-button
                      class="batton mb-3"
                      style=" border-radius: 10px"
                      @click="handlePush"
                      variant="outline-info"
                      size="lg">
                    <i class='bx bxs-plus-square'>{{$t('message.Add')}}</i>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <!--        <b-row>-->
            <!--          <b-col md="6">-->
            <!--            <div class="select w-75">-->
            <!--              <label>{{$t('message.Province')}}</label>-->
            <!--              <b-form-select-->
            <!--                  v-model="form.region_id"-->
            <!--                  :options="regions"-->
            <!--                  text-field="nameuz"-->
            <!--                  value-field="id"-->
            <!--                  @input="fetchRayons"-->
            <!--                  class="form-select d-flex"-->
            <!--                  aria-label="Default select example"></b-form-select>-->
            <!--              <label class="mt-2">{{$t('message.Region')}}</label>-->
            <!--              <b-form-select-->
            <!--                  v-model="form.rayon_id"-->
            <!--                  :options="rayons"-->
            <!--                  text-field="nameuz"-->
            <!--                  value-field="id"-->
            <!--                  @input="fetchSchools"-->
            <!--                  class="form-select d-flex"-->
            <!--                  aria-label="Default select example"></b-form-select>-->
            <!--              <label class="mt-2">{{$t('message.Schools')}}</label>-->
            <!--              <b-form-select-->
            <!--                  v-model="form.school_id"-->
            <!--                  :options="schools"-->
            <!--                  text-field="organizationfullname"-->
            <!--                  value-field="organizationid"-->
            <!--                  class="form-select d-flex"-->
            <!--                  aria-label="Default select example"></b-form-select>-->
            <!--            </div>-->
            <!--          </b-col>-->
            <!--          <b-col md="6">-->
            <!--            <div class="select w-75">-->
            <!--              -->
            <!--            </div>-->
            <!--          </b-col>-->
            <!--        </b-row>-->
            <b-row>
              <b-col md="6" >
                <div class="w-75" style="margin-left: 70px">
                  <label>{{$t('message.Position_level')}}</label>
                  <b-form-select
                      v-model="form.position_level_id"
                      :options="position_level"
                      text-field="name_uz"
                      value-field="id"
                      class="form-select d-flex"
                      aria-label="Default select example"></b-form-select>
                </div>
              </b-col>
              <b-col md="6">
                <div class="w-75" style="margin-left: 70px">
                <label>{{$t('message.Positions')}}</label>
                <b-form-select
                    v-model="form.position_id"
                    :options="positions"
                    text-field="name_uz"
                    value-field="id"
                    class="form-select d-flex"
                    aria-label="Default select example"></b-form-select>
                </div>
              </b-col>
            </b-row>
            <div class="mt-4 d-flex justify-content-end buttons">
              <div>
                <b-button variant="warning" size="lg" @click="fetchAllJobs" style="width: 150px; border-radius: 20px">
                  <div style="color: #185d89">
                    {{$t('message.Search')}}
                  </div>
                </b-button>
                <b-button size="lg" class="me-2" @click="resetFilter" style="width: 150px; background-color: #185d89; border-radius: 20px" >
                  {{$t('message.Clear')}}
                </b-button>
              </div>
            </div>
            <b-card class="mt-3 ms-5">
              <b-table
                  responsive
                  striped
                  hover
                  :items="add_jobs"
                  :fields="fields">
                <template #cell(id)="data">
                  <span class="text-md text-primary"> {{ (data.index + 1) }}</span>
                </template>
                <template #cell(is_active)="{item}">
                  <div class="form-check form-switch mb-3">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="item.is_active"
                        @change="changeVacancyStatus(item)"
                    />
                  </div>
                </template>
                <template #cell(action)="data">
                  <div class="d-flex">
                    <b-button
                        class="sm"
                        style="background-color: #185d89"
                        size="sm"
                        variant="primary"
                        @click="pushRoute(data.item.id)"
                    ><i class='bx bx-show'></i>
                    </b-button>
<!--                    <b-button-->
<!--                        class="sm"-->
<!--                        size="sm"-->
<!--                        variant="warning"-->
<!--                        @click="handleEdit(data.item.id)"-->
<!--                    ><i class='bx bx-pencil'></i>-->
<!--                    </b-button>-->
<!--                    <b-button-->
<!--                        class="sm"-->
<!--                        size="sm"-->
<!--                        variant="danger"-->
<!--                        @click="handleDelete(data.item.id)"-->
<!--                    ><i class='bx bx-trash'></i>-->
<!--                    </b-button>-->
                  </div>
                </template>
              </b-table>
              <div class="w-100 d-flex justify-content-end mt-4">
                <b-pagination
                    v-model="pagination.page"
                    :total-rows="total"
                    :per-page="pagination.pageSize"
                    aria-controls="my-table"
                    @page-click="fetchAllJobs"
                ></b-pagination>
              </div>
            </b-card>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
// import Layout from "../../../../../../layouts/main";
import SideBar from "../../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import {getRayons, getRegions} from "../../../../../../../api/regions";
import {getSchools} from "../../../../../../../api/schools";
import { getPositionLevels, getPositions} from "../../../../../../../api/directories";
import {
  deleteSchoolJobVacancy,
  getSchoolVacancies,
  updateSchoolVacancyStatus
} from "../../../../../../../api/school_job_vacancy";
import HorizontalTopbarInside from "../../../../../../../components/horizontal-topbar-inside";


export default {
  name: "Jobs",
  components: {
    HorizontalTopbarInside, SideBar
  },
  data() {
    return {
      id:null,
      isMenuCondensed: false,
      selected: null,
      regions:[],
      rayons:[],
      schools:[],
      position_level:[],
      positions:[],
      add_jobs: [],
      pagination:{
        page: 1,
        pageSize: 20,
      },
      total: 1,
      fields: [
        {
          key:'id',
          label: this.$t('message.Id'),
        },
        {
          key: 'position_level.name',
          label: this.$t('message.Position_level'),
        },
        {
          key: 'position.name',
          label: this.$t('message.Position_information'),
        },
        {
          key:'work_experience.name',
          label: this.$t('message.Work_experience')
        },
        {
          key:'salary',
          label: this.$t('message.Salary')
        },
        {
          key:'workplace_employment.name',
          label: this.$t('message.Workplace_employment')
        },

        {
          key:"vacancy_count",
          label: this.$t('message.Vacancy_count')
        },
        {
          key:"contact_number",
          label: this.$t('message.Contact_number')
        },
        {
          key:"deadline",
          label: this.$t('message.Deadline')
        },
        {
          key:"description",
          label: this.$t('message.Description')
        },
        {
          key: "is_active",
          label: this.$t('message.Status')
        },
        {
          key:"action",
          label: this.$t('message.Action')
        }
      ],
      form:{
        region_id : null,
        rayon_id : null,
        school_id : null,
        position_level_id : null,
        position_id : null,
      }
    };
  },
  computed: {
    ...layoutComputed,
  },
  created() {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchRegions()
    this.fetchPositionLevel()
    this.fetchPositions()
    this.fetchAllJobs()
  },
  methods: {
    fetchRegions(){
      getRegions().then(response => {
        this.regions = response.data.data
      })
    },
    fetchRayons(){
      this.form.rayon_id = null
      getRayons(this.form.region_id).then(response => {
        this.rayons = response.data.data
      })
    },
    fetchSchools(){
      getSchools({oblastid: this.form.region_id , regionid: this.form.rayon_id}).then(response => {
        this.schools = response.data.data
      })
    },
    fetchPositionLevel(){
      getPositionLevels().then(response => {
        this.position_level = response.data.data
      })
    },
    fetchPositions(){
      getPositions().then(response => {
        this.positions = response.data.data
      })
    },
    fetchAllJobs(){
      getSchoolVacancies({...this.form, ...this.pagination}).then(response => {
        this.add_jobs = response.data.data.data
        this.total = response.data.data.total
      })
    },
    resetFilter() {
      this.form.rayon_id = null;
      this.form.position_level_id = null;
      this.form.position_id = null
      this.form.region_id = null;
      this.form.school_id = null;
      this.fetchAllJobs()
    },
    changeVacancyStatus(item) {
      // eslint-disable-next-line no-console
      console.log(item)
      updateSchoolVacancyStatus({id: item.id, is_active: item.is_active}).then(() => {
        this.$vs.notification({
          flat: true,
          color:"success",
          position: 'top-right',
          title: this.$t('message.Success'),
          text: ``
        })
      })
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
      handlePush(){
        this.$router.push({name: 'addjob'})
      },
    pushRoute(id){
      this.$router.push({name:'job-information', params: {id}})
    },
    handleEdit(id){
      this.id = id
      this.$router.push({name:'editjob', params: {id}})
    },
    handleDelete(id) {
      if (id) {
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            // eslint-disable-next-line no-unused-vars
            deleteSchoolJobVacancy({ id }).then(res => {
              this.$swal({
                icon: 'success',
                position: 'center',
                title: 'Deleted!',
                text: 'Your file has been deleted.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
              this.fetchAllJobs()
            })
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
      }
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #185d89;
}
.btn{
  width: 140px;
  height: 50px;
  margin-left: 10px;
}
.bx{
  font-size: 19px;
}
.select{
  margin: auto;
}
.sm{
  width: 40px;
  height: 40px;
}
.buttons{
  margin-right: 50px;
}
</style>



